(function () {
  'use strict';

  var revealIo = null;
  var revealDelayCount = 0;

  function revealObserve(nodes) {
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    if (!revealIo) {
      revealIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealIo.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }
    nodes.forEach(function (n) {
      n.style.transitionDelay = ((revealDelayCount % 4) * 90) + 'ms';
      revealDelayCount++;
      revealIo.observe(n);
    });
  }

  function initReveal() {
    var nodes = document.querySelectorAll('[data-reveal]:not(.is-visible)');
    revealObserve(Array.prototype.slice.call(nodes));

    // Content added after this point (product recommendations, quick-add
    // re-renders, section reloads, etc.) never got scanned by the block
    // above, so it was permanently stuck at opacity:0 — invisible but still
    // present/hoverable in the DOM. Keep watching so it gets revealed too.
    if (!('MutationObserver' in window) || document.__neslarRevealMo) return;
    var mo = new MutationObserver(function (mutations) {
      var found = [];
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-reveal]:not(.is-visible)')) {
            found.push(node);
          }
          if (node.querySelectorAll) {
            var nested = node.querySelectorAll('[data-reveal]:not(.is-visible)');
            for (var i = 0; i < nested.length; i++) found.push(nested[i]);
          }
        });
      });
      if (found.length) revealObserve(found);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.__neslarRevealMo = mo;
  }

  function initParallax() {
    var nodes = document.querySelectorAll('[data-neslar-parallax]');
    if (!nodes.length) return;
    var ticking = false;
    function update() {
      nodes.forEach(function (n) {
        var speed = parseFloat(n.getAttribute('data-neslar-parallax')) || 0.1;
        // Measure the stable, untransformed parent instead of the node itself:
        // reading the node's own rect after a transform has been applied
        // compounds on every scroll event, eventually drifting the element
        // thousands of pixels off-screen the further down the page it sits.
        var r = (n.parentElement || n).getBoundingClientRect();
        var offset = (r.top + r.height / 2) - (window.innerHeight / 2);
        var shift = offset * -speed;
        // Hard safety cap: the background must never be able to drift far
        // enough to leave its own frame, no matter what the scroll math does.
        var cap = 120;
        if (shift > cap) shift = cap;
        if (shift < -cap) shift = -cap;
        n.style.transform = 'translateY(' + shift + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initSubmenuFix() {
    // This forces the submenu into a narrow floating panel sized for the
    // glass pill header. Only relevant when the transparent/pill header is
    // active — with the default full-width Horizon header it fights the
    // native mega-menu grid and stops submenus from opening at all.
    var header = document.querySelector('header-component');
    if (!header || !header.hasAttribute('transparent')) return;

    // Horizon's own script continuously recalculates and re-applies inline
    // width/right on the submenu panel (sized for a full-width header),
    // repeatedly stomping any one-time override — even an inline one set
    // with !important. A MutationObserver re-applies our values every time
    // Horizon's script touches the style attribute, so ours is always the
    // last word.
    var SEL = ".menu-list__list-item:not([slot='overflow']) > .menu-list__submenu .menu-list__submenu-inner";
    var applying = false;
    function fixInner(inner) {
      if (!inner || applying) return;
      applying = true;
      inner.style.setProperty('position', 'absolute', 'important');
      inner.style.setProperty('left', '0', 'important');
      inner.style.setProperty('right', 'auto', 'important');
      inner.style.setProperty('top', '0', 'important');
      inner.style.setProperty('width', '300px', 'important');
      inner.style.setProperty('max-width', '90vw', 'important');
      applying = false;
    }
    function watch(inner) {
      if (!inner || inner.dataset.neslarSubmenuWatched) return;
      inner.dataset.neslarSubmenuWatched = 'true';
      fixInner(inner);
      var mo = new MutationObserver(function () { fixInner(inner); });
      mo.observe(inner, { attributes: true, attributeFilter: ['style'] });
    }
    document.querySelectorAll(SEL).forEach(watch);
    document.addEventListener('mouseover', function (e) {
      var item = e.target.closest ? e.target.closest(".menu-list__list-item:not([slot='overflow'])") : null;
      if (!item) return;
      watch(item.querySelector('.menu-list__submenu-inner'));
    });
  }

  function initHeaderScroll() {
    var header = document.querySelector('header-component');
    if (!header) return;
    if (header.hasAttribute('transparent')) {
      header.classList.add('neslar-glass');
    }
    function onScroll() {
      header.classList.toggle('header-scrolled', window.scrollY > 30);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initBeforeAfter() {
    document.querySelectorAll('[data-neslar-ba]').forEach(function (box) {
      var top = box.querySelector('[data-neslar-ba-top]');
      var handle = box.querySelector('[data-neslar-ba-handle]');
      if (!top || !handle) return;
      var dragging = false;
      var pointerId = null;
      function move(clientX) {
        var r = box.getBoundingClientRect();
        var p = (clientX - r.left) / r.width;
        p = Math.max(0.02, Math.min(0.98, p));
        var pct = p * 100;
        top.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
      }
      function stop() {
        dragging = false;
        if (pointerId !== null && box.hasPointerCapture && box.hasPointerCapture(pointerId)) {
          box.releasePointerCapture(pointerId);
        }
        pointerId = null;
      }
      box.addEventListener('pointerdown', function (e) {
        dragging = true;
        pointerId = e.pointerId;
        // Sin esto, en móvil el navegador puede cancelar el gesto a mitad de
        // camino (lo interpreta como scroll) y la barra se queda pillada.
        if (box.setPointerCapture) box.setPointerCapture(e.pointerId);
        move(e.clientX);
      });
      box.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        move(e.clientX);
      });
      box.addEventListener('pointerup', stop);
      box.addEventListener('pointercancel', stop);
    });
  }

  function initHairSelector() {
    document.querySelectorAll('[data-neslar-hair]').forEach(function (root) {
      var chips = root.querySelectorAll('[data-hair-chip]');
      var img = root.querySelector('[data-hair-img]');
      var desc = root.querySelector('[data-hair-desc]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          var newSrc = chip.getAttribute('data-hair-img-src');
          var newDesc = chip.getAttribute('data-hair-desc-text');
          if (img && newSrc) {
            img.style.opacity = '0';
            setTimeout(function () { img.src = newSrc; img.style.opacity = '1'; }, 200);
          }
          if (desc && newDesc) desc.textContent = newDesc;
        });
      });
    });
  }

  function initGallerySelector() {
    document.querySelectorAll('[data-neslar-gallery]').forEach(function (root) {
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      var main = root.querySelector('[data-gallery-main]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-gallery-src');
          if (main && src) {
            main.style.opacity = '0';
            setTimeout(function () { main.src = src; main.style.opacity = '1'; }, 180);
          }
        });
      });
    });
  }

  function initHeaderOffset() {
    var header = document.querySelector('header-component');
    var announcement = document.querySelector('.announcement-bar');
    if (!header && !announcement) return;
    function update() {
      var total = (header ? header.offsetHeight : 0) + (announcement ? announcement.offsetHeight : 0);
      document.documentElement.style.setProperty('--neslar-header-offset', total + 'px');
    }
    update();
    // Header height can change after first paint (web font swap, logo image
    // decode, layout reflow on load), so re-measure a few times after those
    // events instead of trusting only the very first synchronous read.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update);
    }
    window.addEventListener('load', update);
    setTimeout(update, 400);
    setTimeout(update, 1200);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(update);
      if (header) ro.observe(header);
      if (announcement) ro.observe(announcement);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }
  }

  function initScrollAutoplay() {
    document.querySelectorAll('[data-neslar-scroll-autoplay]').forEach(function (root) {
      if (root.dataset.neslarScrollAutoplayInit) return;
      root.dataset.neslarScrollAutoplayInit = 'true';
      var track = root.querySelector('.neslar-collections__grid--carousel');
      if (!track) return;
      var speed = (parseFloat(root.getAttribute('data-scroll-autoplay-speed')) || 4) * 1000;
      var paused = false;
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () {
        if (paused) return;
        var card = track.querySelector('.neslar-ccard');
        if (!card) return;
        var step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 22);
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        track.scrollTo({
          left: atEnd ? 0 : track.scrollLeft + step,
          behavior: 'smooth'
        });
      }, speed);
    });
  }

  function initFeaturedCarousel() {
    document.querySelectorAll('[data-neslar-featured-track]').forEach(function (track) {
      if (track.dataset.neslarFeaturedInit) return;
      track.dataset.neslarFeaturedInit = 'true';

      var root = track.closest('.neslar-featured');
      var progressBar = root ? root.querySelector('[data-neslar-featured-progress-bar]') : null;
      var halfWidth = track.scrollWidth / 2;

      function wrap() {
        if (!halfWidth) return;
        if (track.scrollLeft >= halfWidth) {
          track.scrollLeft -= halfWidth;
        } else if (track.scrollLeft < 0) {
          track.scrollLeft += halfWidth;
        }
      }

      function updateProgress() {
        if (!progressBar || !halfWidth) return;
        var pct = (track.scrollLeft % halfWidth) / halfWidth;
        var trackEl = progressBar.parentElement;
        var maxTranslate = trackEl.clientWidth - progressBar.clientWidth;
        progressBar.style.transform = 'translateX(' + Math.max(0, pct * maxTranslate) + 'px)';
      }

      track.addEventListener('scroll', function () {
        wrap();
        updateProgress();
      }, { passive: true });

      // Arrastre con el ratón (además del scroll/touch nativo). Sin
      // setPointerCapture en el track: capturar el puntero ahí impedía que
      // el click llegara de forma nativa a los enlaces de producto dentro
      // del carrusel, así que nunca navegaban. Se sigue el arrastre con
      // listeners en window para que funcione aunque el cursor salga del
      // carrusel mientras se arrastra.
      var isDown = false;
      var dragged = false;
      var startX = 0;
      var scrollStart = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        isDown = true;
        dragged = false;
        startX = e.clientX;
        scrollStart = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 6) dragged = true;
        if (dragged) track.scrollLeft = scrollStart - delta;
      });
      function endDrag() {
        isDown = false;
      }
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
      track.addEventListener(
        'click',
        function (e) {
          if (dragged) {
            e.preventDefault();
            e.stopPropagation();
          }
          dragged = false;
        },
        true
      );

      // Autoplay (opcional, según ajustes de la sección)
      var speedAttr = root && root.hasAttribute('data-neslar-featured-autoplay')
        ? root.getAttribute('data-featured-autoplay-speed')
        : null;
      if (speedAttr !== null) {
        var speed = (parseFloat(speedAttr) || 4) * 1000;
        var paused = false;
        root.addEventListener('mouseenter', function () { paused = true; });
        root.addEventListener('mouseleave', function () { paused = false; });
        root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
        setInterval(function () {
          if (paused || isDown) return;
          var card = track.querySelector('.neslar-pcard');
          if (!card) return;
          var step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 22);
          track.scrollTo({ left: track.scrollLeft + step, behavior: 'smooth' });
        }, speed);
      }

      updateProgress();
    });
  }

  function initAnnouncementCarousel() {
    document.querySelectorAll('[data-neslar-carousel]').forEach(function (root) {
      if (root.dataset.neslarCarouselInit) return;
      root.dataset.neslarCarouselInit = 'true';
      var slides = root.querySelectorAll('.neslar-announcement-carousel__slide');
      if (slides.length < 2) return;
      var speed = (parseFloat(root.getAttribute('data-carousel-speed')) || 5) * 1000;
      var idx = 0;
      setInterval(function () {
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, speed);
    });
  }

  function init() {
    initReveal();
    initParallax();
    initHeaderOffset();
    initAnnouncementCarousel();
    initScrollAutoplay();
    initFeaturedCarousel();
    initSubmenuFix();
    initHeaderScroll();
    initBeforeAfter();
    initHairSelector();
    initGallerySelector();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
